import { pendingNavHrefAtom } from '@/atoms/sideNavAtoms';
import { useResetProjectsComposerContext } from '@/features/projects/resetProjectsComposerContext';
import { WORK_CHAT_HOME_PATH } from '@heidi/agents/contracts';
import { pendingWorkHomeViewAtom, pendingWorkModeAtom } from '@heidi/agents/data';
import { useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

export function useOpenEvidenceHome(): () => void {
  const router = useRouter();
  const setPendingNavHref = useSetAtom(pendingNavHrefAtom);
  const setPendingWorkHomeView = useSetAtom(pendingWorkHomeViewAtom);
  const setPendingWorkMode = useSetAtom(pendingWorkModeAtom);
  const resetProjectsComposerContext = useResetProjectsComposerContext();

  return useCallback(() => {
    resetProjectsComposerContext();
    setPendingWorkHomeView('home');
    setPendingWorkMode('evidence');
    if (router.asPath !== WORK_CHAT_HOME_PATH) {
      setPendingNavHref(WORK_CHAT_HOME_PATH);
    }
    void router.push(WORK_CHAT_HOME_PATH);
  }, [
    resetProjectsComposerContext,
    router,
    setPendingNavHref,
    setPendingWorkHomeView,
    setPendingWorkMode,
  ]);
}
